import { z } from "zod";

export const ValidationUpdateResponse = z.object({
    success: z.literal(false),
    message: z.literal("Validation errors"),
    code: z.literal(422),
    errors: z.object({
        name: z.array(z.string()),
        accommodation_type: z.array(z.string()),
        preferred_currency: z.array(z.string()),
        time_zone: z.array(z.string()),
        primary_email: z.array(z.string()),
        cc_emails: z.array(z.string()),
        accounting_email: z.array(z.string()),
        mobile_number_country_code: z.array(z.string()),
        mobile_number: z.array(z.string()),
        enable_cvv: z.array(z.string()),
        primary_phone_country_code: z.array(z.string()),
        primary_phone: z.array(z.string()),
        website: z.array(z.string()),
        country: z.array(z.string()),
        state: z.array(z.string()),
        city: z.array(z.string()),
        street_address: z.array(z.string()),
        postal_code: z.array(z.string()),
        prefix_booking_number: z.array(z.string()),
        hotel_tax_number: z.array(z.string()),
        latitude: z.array(z.string()),
        longitude: z.array(z.string()),
        description: z.array(z.string()),
        facebook_link: z.array(z.string()),
        instagram_link: z.array(z.string()),
        youtube_link: z.array(z.string()),
        tiktok_link: z.array(z.string()),
        logo: z.array(z.string()),
        cover_image: z.array(z.string()),
        created_at: z.array(z.string()),
        updated_at: z.array(z.string()),
        is_full_sync: z.array(z.string()),
        property_type: z.array(z.string()),
        logo_url: z.array(z.string()),
    }),
});